import { render, staticRenderFns } from "./plain-text-email-templates-widget.vue?vue&type=template&id=11e952b4&"
import script from "./plain-text-email-templates-widget.vue?vue&type=script&lang=js&"
export * from "./plain-text-email-templates-widget.vue?vue&type=script&lang=js&"
import style0 from "./plain-text-email-templates-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports